import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import { publicPath } from "@/utils/base";
import dataJson from "@/../public/data.json";
import "./index.less";

const prefix = "story";

function Story() {
  const { learn_more, design } = dataJson;
  const navigate = useNavigate();
  return (
    <div className={prefix} style={{ backgroundImage: `url(${design.story_bg})` }}>
      <div className={`${prefix}-inner`}>
        <div className={`${prefix}-title`}>{design.story_title}</div>
        <div className={`${prefix}-describe`}>{design.story_describe}</div>
        <Button
          shape="round"
          style={{ marginTop: 50, background: "#FFFFFF", color: "#1072FA" }}
          onClick={() => {
            navigate(`${publicPath}/design_story`);
          }}
        >
          {learn_more}
        </Button>
      </div>
    </div>
  );
}

export default Story;
